module.exports = __webpack_public_path__ + "static/media/globe.4b772731.gif";